import React from "react";
import {
  FaMapMarkerAlt,
  FaClock,
  FaMobileAlt,
  FaShieldAlt,
  FaLaptopCode,
  FaWhatsapp,
} from "react-icons/fa";

import "./FAQ.css";

function FAQ() {
  const faqs = [
    {
      icon: <FaMapMarkerAlt />,
      question: "Do you repair phones at my location?",
      answer:
        "Yes. Our technicians come directly to your home, office, or preferred location anywhere in our service areas.",
    },
    {
      icon: <FaClock />,
      question: "How long does a repair take?",
      answer:
        "Most repairs are completed within 30 to 60 minutes depending on the device and issue.",
    },
    {
      icon: <FaMobileAlt />,
      question: "Do you repair both iPhone and Android devices?",
      answer:
        "Yes. We repair all major brands including iPhone, Samsung, Huawei, Xiaomi, Oppo, Vivo, and more.",
    },
    {
      icon: <FaShieldAlt />,
      question: "Do you provide a warranty?",
      answer:
        "Yes. We provide warranty coverage on eligible repairs and replacement parts.",
    },
    {
      icon: <FaLaptopCode />,
      question: "Do you fix software issues?",
      answer:
        "Yes. We resolve software problems including updates, boot issues, performance problems, data recovery, and more.",
    },
    {
      icon: <FaWhatsapp />,
      question: "How can I contact you?",
      answer:
        "You can contact us via WhatsApp, phone call, or through the contact form on our website.",
    },
  ];

  return (
    <section className="faq-section">
      <div className="container">
        <div className="section-heading text-center" data-aos="fade-up">
          <span className="section-badge">Frequently Asked Questions</span>

          <h2 className="section-title">Got Questions? We've Got Answers</h2>

          <p className="section-description">
            Find answers to the most common questions about our mobile repair
            services.
          </p>
        </div>

        <div className="row">
          {faqs.map((faq, index) => (
            <div
              className="col-lg-6 col-md-6 col-12 mb-3"
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="faq-card">
                <div className="faq-icon">{faq.icon}</div>

                <h4>{faq.question}</h4>

                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;
